export type ViewTier = 'private' | 'tier1' | 'tier2' | 'tier3' | 'basic' | 'full'; // 'full' for backward compat
export type TimeWindow = '1m' | '3m' | '6m' | '1y' | '2y';

const PREFS_KEY = 'vester:portfolio:prefs';

export interface PortfolioPrefs {
  selfViewTier: ViewTier;
  window: TimeWindow;
  lastFriendId?: string;
}

const DEFAULT_PREFS: PortfolioPrefs = {
  selfViewTier: 'private',
  window: '6m',
};

export function loadPortfolioPrefs(): PortfolioPrefs {
  try {
    const stored = localStorage.getItem(PREFS_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      // Map 'full' to 'private' for backward compatibility
      if (parsed.selfViewTier === 'full') {
        parsed.selfViewTier = 'private';
      }
      return { ...DEFAULT_PREFS, ...parsed };
    }
  } catch (error) {
    console.warn('Failed to load portfolio prefs:', error);
  }
  
  // Migrate from old CacheKeys.portfolio.viewAs() format
  try {
    const oldKey = 'portfolio:viewAs';
    const oldValue = localStorage.getItem(oldKey);
    if (oldValue) {
      const viewAsTier = JSON.parse(oldValue) as ViewTier;
      if (['private', 'tier1', 'tier2', 'tier3', 'basic', 'full'].includes(viewAsTier)) {
        const selfViewTier = viewAsTier === 'full' ? 'private' : viewAsTier;
        const prefs: PortfolioPrefs = { ...DEFAULT_PREFS, selfViewTier };
        savePortfolioPrefs(prefs); // Save to new format
        console.log(`✅ Migrated portfolio preference from old format: ${viewAsTier} → ${selfViewTier}`);
        return prefs;
      }
    }
  } catch (error) {
    console.warn('Failed to migrate old portfolio viewAs preference:', error);
  }
  
  return DEFAULT_PREFS;
}

export function savePortfolioPrefs(prefs: Partial<PortfolioPrefs>): void {
  try {
    const current = loadPortfolioPrefs();
    const updated = { ...current, ...prefs };
    localStorage.setItem(PREFS_KEY, JSON.stringify(updated));
  } catch (error) {
    console.warn('Failed to save portfolio prefs:', error);
  }
}

